export const SET_DEFINITIONS_DATA = 'SET_DEFINITIONS_DATA';
export const SET_SINGLE_DEFINITIONS_DATA = 'SET_SINGLE_DEFINITIONS_DATA';
export const ADD_DEFINITIONS_DATA = 'ADD_DEFINITIONS_DATA';
export const DELETE_DEFINITIONS_DATA = 'DELETE_DEFINITIONS_DATA';
export const ADD_DEFINITIONS_IMAGE = 'DELETE_DEFINITIONS_IMAGE';



// WEBPACK FOOTER //
// ./src/store/modules/definitions/action-types.js